import styled from 'styled-components';
import { sharedInputStyles } from './sharedInputStyles';

const LabelWrapper = styled.label.attrs((props) => ({
  onClick: props.$preventLabelClick ? (e) => e.preventDefault() : undefined,
}))`
  ${sharedInputStyles}
  /* max-width: 210px; */
  display: block;

  .label-text {
    text-align: center;
  }
`;

export default LabelWrapper;
